import { Instance } from 'mobx-state-tree';
import { VisitPaginatedDtoModelBase } from './VisitPaginatedDtoModel.base';

/* The TypeScript type of an instance of VisitPaginatedDtoModel */
export interface VisitPaginatedDtoModelType extends Instance<typeof VisitPaginatedDtoModel.Type> {}

/* A graphql query fragment builders for VisitPaginatedDtoModel */
export { selectFromVisitPaginatedDto, visitPaginatedDtoModelPrimitives, VisitPaginatedDtoModelSelector } from './VisitPaginatedDtoModel.base';

/**
 * VisitPaginatedDtoModel
 */
export const VisitPaginatedDtoModel = VisitPaginatedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
